import { ReactComponent as IdentitySet } from "./identity-set.svg";
import { ReactComponent as IdentityKilled } from "./identity-killed.svg";
import { ReactComponent as JudgementRequested } from "./judgement-requested.svg";
import { ReactComponent as JudgementGiven } from "./judgement-given.svg";
import { ReactComponent as JudgementUnrequested } from "./judgement-unrequested.svg";
import { ReactComponent as IdentityCleared } from "./identity-cleared.svg";
import { ReactComponent as SubIdentityRevoked } from "./sub-identity-revoked.svg";
import { ReactComponent as SubIdentityAdded } from "./sub-identity-added.svg";
import { ReactComponent as SubIdentityRemoved } from "./sub-identity-removed.svg";
import { ReactComponent as setSubs } from "./set-subs.svg";
import { ReactComponent as renameSub } from "./rename-sub-identity.svg";
import { ReactComponent as setFee } from "./set-fee.svg";
import { ReactComponent as setFields } from "./set-fields.svg";
import { ReactComponent as setAccountId } from "./set-account-id.svg";
import { ReactComponent as RegistrarAdded } from "./registrar-added.svg";

export const IdentityTimelineIcons = {
  IdentitySet,
  IdentityKilled,
  JudgementRequested,
  JudgementGiven,
  JudgementUnrequested,
  IdentityCleared,
  SubIdentityRevoked,
  SubIdentityAdded,
  SubIdentityRemoved,
  setSubs,
  renameSub,
};

export const RegistrarTimelineIcons = {
  setFee,
  setFields,
  setAccountId,
  RegistrarAdded,
};
